"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateInsuranceOptions = void 0;
const tslib_1 = require("tslib");
const common_1 = require("../../common");
const common_2 = require("../common");
const insurance_payment_calculator_1 = require("./insurance-payment-calculator");
const models_1 = require("./models");
function validateValueLessThanAmount(value, amount, property) {
    if (!value) {
        return [];
    }
    const errors = [];
    errors.push(...common_2.validatePositiveNumber(value, property));
    if (value >= amount) {
        errors.push(`The ${property} of ${value} is more than the amount ${amount}.`);
    }
    return errors;
}
function validateLumpSumAmount(_a) {
    var { lumpSumAmount } = _a, options = tslib_1.__rest(_a, ["lumpSumAmount"]);
    if (!lumpSumAmount) {
        return [];
    }
    const errors = [];
    errors.push(...validateValueLessThanAmount(lumpSumAmount, options.amount, 'lumpSumAmount'));
    const result = insurance_payment_calculator_1.calculateInsurancePaymentOptions(Object.assign({}, options));
    if (!result.isValid) {
        errors.push('Unable to calculate rates for options without lump sum');
    }
    else if (result.paymentOptions.every(opt => opt.premium > lumpSumAmount)) {
        errors.push(`Lump sum amount must be greater than premium`);
    }
    return errors;
}
function validateInsuranceOptions(options) {
    const errors = [];
    errors.push(...common_2.validateEnum(options.product, 'product', models_1.InsuranceProducts));
    errors.push(...common_2.validateEnum(options.commission, 'commission', models_1.CommissionOptions));
    errors.push(...common_2.validateEnum(options.paymentPeriod, 'paymentPeriod', common_1.PaymentPeriods));
    errors.push(...common_2.validateEnum(options.paymentMode, 'paymentMode', common_1.PaymentModes));
    errors.push(...common_2.validateEnum(options.paymentMethod, 'paymentMethod', common_1.PaymentMethods));
    errors.push(...common_2.validateEnum(options.state, 'state', common_1.States));
    errors.push(...common_2.validateEnum(options.billingType, 'billingType', common_1.BillingTypes));
    errors.push(...common_2.validatePositiveNumber(options.amount, 'amount'));
    errors.push(...common_2.validatePositiveNumber(options.age, 'age'));
    errors.push(...validateValueLessThanAmount(options.downPaymentAmount, options.amount, 'downPaymentAmount'));
    errors.push(...validateLumpSumAmount(options));
    if (!models_1.SUPPORTED_INSURANCE_PRODUCTS.includes(options.product)) {
        errors.push(`The product ${options.product} is not supported at this time.`);
    }
    if (options.downPaymentAmount && options.lumpSumAmount) {
        errors.push(`Providing down payment amount and lump sum amount is not allowed`);
    }
    return {
        isValid: errors.length === 0,
        errors,
    };
}
exports.validateInsuranceOptions = validateInsuranceOptions;
//# sourceMappingURL=insurance-options-validator.js.map